import queryString from 'query-string';

export default class QueryURLBuilder {
    constructor() {
        this._baseUrl = ''
        this._prefix = ''
        this._queryParams = {};
        
        this._init();
    }

    _init() {
        let result = queryString.parseUrl(window.location.href);
        this._baseUrl = result.url;
        this._queryParams = this._reformatObjectKeys(result.query);
    }

    _appendObjectKeys(obj) {
        let result = {};
        for(let key in obj) {
            if(obj.hasOwnProperty(key)) {
                let value = obj[key];
                if (value && ( value.length > 0 || value != '')) {
                    result[this._prefix + key] = value;
                }
            }
        }

        return result;
    }

    _reformatObjectKeys(obj) {
        let result = {};
        for(let key in obj) {
            let value = obj[key];
            key = key.replace(this._prefix, '');
            key = key.replace('[]', '');
            result[key] = ( isNaN( parseFloat( value ) ) ) ? value : parseFloat( value );
        }
        return result;
    }

    serialize(obj) {
        obj = this._appendObjectKeys(obj);
        let result = queryString.stringify(obj, {arrayFormat: 'bracket'});
        let url = ( result.length > 0 ) ? this._baseUrl + '?' + result : this._baseUrl;
        history.pushState(result, null, url );
    }

    getQueryParams() {
        return this._queryParams;
    }
}


// WEBPACK FOOTER //
// ./src/js/helpers/query-url-builder.js